var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VBtn',{style:('min-width: 0px; max-width: 20px; max-height: 25px; ' + (_vm.$vuetify.breakpoint.mdAndUp ? 'margin-top: 25px' : '')),attrs:{"disabled":_vm.disabled,"color":"primary"},on:{"click":_vm.click}},[_c('VIcon',[_vm._v("add")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }